import { render, staticRenderFns } from "./kategoria.vue?vue&type=template&id=520f66a4&scoped=true&"
import script from "./kategoria.vue?vue&type=script&lang=ts&"
export * from "./kategoria.vue?vue&type=script&lang=ts&"
import style0 from "./kategoria.vue?vue&type=style&index=0&id=520f66a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f66a4",
  null
  
)

export default component.exports